<template>
	<div>
		<h4>这是子组件</h4>
		<input type="text" placeholder="请输入">
		<slot></slot>
		<slot name="myslot" :data='list'></slot>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list:[
					{name:"Tom",age:15},
					{name:"Jim",age:25},
					{name:"Tony",age:13}
				]
			}
		},
		props: [],
		mounted() {

		},
		methods: {

		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/demo/son.vue